exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td[data-v-033e37df],.table th[data-v-033e37df]{vertical-align:middle}", ""]);

// exports
